import PropTypes from 'prop-types'
import React, { Component } from 'react'
import parse from 'url-parse'
import classnames from 'classnames'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { FormattedMessage } from 'react-intl'
import { SubmissionError } from 'redux-form'
import LoginForm from './LoginForm'
import styles from './_login.css'
import { Loader, Button } from 'components/util'
import * as auth from 'services/auth/selectors'
import * as authActions from 'services/auth/actions'
import * as site from 'services/site/selectors'

const mapStateToProps = (state) => ({
  error: auth.selectError(state),
  loggingIn: auth.selectLoggingIn(state),
  dev: site.selectDev(state),
})

const mapDispatchToActions = {
  ...authActions,
}

export class Login extends Component {

  static propTypes = {
    leftAlign: PropTypes.bool,
    loggingIn: PropTypes.bool,
    login: PropTypes.func.isRequired,
    loginWithFacebook: PropTypes.func,
    onClickSignup: PropTypes.func.isRequired,
    onClickForgotPassword: PropTypes.func.isRequired,
    onLoginSuccess: PropTypes.func.isRequired,
    clearLegacy: PropTypes.func.isRequired,
    initSignupWithFacebook: PropTypes.func,
    dev: PropTypes.bool,
    reload: PropTypes.bool,
  };

  static defaultProps = {
    reload: false,
    leftAlign: false,
  };

  state = {
    submitting: false,
    error: null,
  }

  componentWillMount () {
    this.props.clearLegacy()
  }

  handleLogin = ({ email, password }) => {
    const { dev, reload } = this.props

    this.setState({ submitting: true, error: null, userError: null })

    return this.props.login({ username: email, password }, reload)
      .then(this.props.onLoginSuccess)
      .catch((err) => {

        this.setState({ submitting: false })

        if (err.user) {
          // there was a problem reloading user
          // the user is probably still logged in
          if (dev) {
            err.url = parse(err.config.url, true)
            this.setState({ userError: err })
          } else {
            this.setState({ error: 'unknown' })
          }
        } else if (err
          && err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error === 'access_denied'
        ) {
          throw new SubmissionError({ _error: err.response.data.error })
        } else {
          this.setState({ error: 'unknown' })
        }
      })
  }

  handleClickSignup = (evt) => {
    const { onClickSignup } = this.props
    evt.preventDefault()
    if (onClickSignup) { onClickSignup(evt) }
  }

  handleClickForgotPassword = (evt) => {
    const { onClickForgotPassword } = this.props
    evt.preventDefault()
    if (onClickForgotPassword) { onClickForgotPassword(evt) }
  }

  handleClickLoginWithFacebook = () => {
    const { onClickSignup, reload } = this.props

    this.setState({ submitting: true, error: null, userError: null })

    this.props.loginWithFacebook(reload)
      .then(this.props.onLoginSuccess)
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.error) {
          // unable to login via facebook, maybe they want to create
          // an account w/ facebook instead?
          if (err.response.data.error === 'access_denied') {
            return this.props.initSignupWithFacebook()
              .then(() => { if (onClickSignup) { onClickSignup() } })
          } else {
            this.setState({ submitting: false, error: err.response.data.error })
          }
        } else {
          this.setState({ submitting: false, error: 'unknown' })
        }
      })

  }

  getErrorMessage = (code) => {
    const messages = {
      'unknown': (<FormattedMessage
        id='auth.login.error.unknown'
        defaultMessage='An unknown error has occured. Please try again.'
      />),
    }

    if (code in messages) {
      return messages[code]
    }
  }

  render () {
    const { leftAlign, dev } = this.props
    const { submitting, error, userError } = this.state

    return (
      <div className={styles.container}>

        <ReactCSSTransitionGroup
          component='div'
          transitionName='fade'
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {submitting ?
            <div key='loader'>
              <div className={styles.loader}>
                <Loader height={50} width={50} />
              </div>
            </div>
          : null}
        </ReactCSSTransitionGroup>

        <a
          href='/auth/signup'
          onClick={this.handleClickSignup}
          className={classnames(styles.alternateLink, {
            [styles.leftAlign]: leftAlign,
          })}
        >
          <FormattedMessage
            id='auth.login.sign_up'
            defaultMessage='Sign up'
          />
        </a>

        <div className={styles.facebook}>
          <Button
            disabled={submitting}
            type='facebook'
            icon='facebook_circle'
            className={styles.button}
            onClick={this.handleClickLoginWithFacebook}
          >
            <FormattedMessage
              id='auth.login.signup_with_facebook'
              defaultMessage='Log in with Facebook'
            />
          </Button>
        </div>

        <div className={styles.or}>
          <span className={styles.hr} />
          <span className={styles.orText}>
            <FormattedMessage id='auth.login.or' defaultMessage='or' />
          </span>
          <span className={styles.hr} />
        </div>

        {error ?
          <div className={styles.error}>
            {this.getErrorMessage(error)}
          </div>
        : null}

        <LoginForm
          loggingIn={submitting}
          onSubmit={this.handleLogin}
          onClickForgotPassword={this.handleClickForgotPassword}
        />

        {/*
          DEBUG information, only shown in local/devint
          Useful because DEVINT endpoints are often troublesome
        */}
        {userError && dev ?
          <div className={styles.userError}>
            <div className={styles.userErrorDescription}>
              You were logged in successfully, however there was an error fetching your user data.
              Feel free to try again, or just proceed to <a href="/my_home">my home</a>.
            </div>
            <div className={styles.userErrorMessage}>
              {userError.toString()} <br />
              {userError.response.status === 502 && 'Bad Gateway, server may be down or restarting'}
              {userError.response.status === 503 && 'Service Unavailable, server may be down or restarting'}
              {userError.response.status === 504 && 'Gateway Timeout, server took too long'}
            </div>
            <div><b>Host: </b>{userError.url.host}</div>
            <div><b>Path: </b>{userError.url.pathname}</div>
          </div>
        : null}

      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(Login)




// WEBPACK FOOTER //
// ./src/components/auth/login/Login.jsx